import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Collapse, Descriptions, Input, Space, Spin, Tag, Typography, message } from 'antd';
import { useTranslation } from '../../../i18n';

const { Text } = Typography;
const ok = (r) => r && r.status === 'success';

/** Admin: a VDS VM's host CPU pins (GET /vms/{id}/vds, repin, manual pin). */
const VdsPinTab = ({ id, api, active }) => {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState(false);
    const [cpus, setCpus] = useState('');

    const load = useCallback(async () => {
        const r = await api.getVmVds(id);
        setData(ok(r) ? r.data : { vds: false });
    }, [api, id]);
    useEffect(() => { if (active) load(); }, [active, load]);

    const run = async (p) => {
        setBusy(true);
        const r = await p;
        setBusy(false);
        if (ok(r)) { message.success(r.msg || t('Saved')); load(); } else message.error(r?.msg || r?.error || t('Operation failed'));
    };

    if (!data) return <Spin />;
    const p = data.pins;
    return (
        <Card size="small" title={t('CPU pinning')} extra={
            <Button size="small" loading={busy} onClick={() => run(api.repinVmVds(id))}>{t('Re-pin')}</Button>
        }>
            {!p ? <Text type="secondary">{t('Not pinned')}</Text> : (
                <Descriptions size="small" column={1}>
                    <Descriptions.Item label="vCPU → CPU">
                        <Space size={4} wrap>
                            {(p.vcpupin || []).map((c, i) => <Tag key={i}>{i} → {c}</Tag>)}
                            {data.manual && <Tag color="orange">{t('Manual')}</Tag>}
                        </Space>
                    </Descriptions.Item>
                    <Descriptions.Item label={t('Emulator threads')}>{p.emulatorpin || '-'}</Descriptions.Item>
                    {p.numatune && <Descriptions.Item label="NUMA">{`${p.numatune.mode} · ${p.numatune.nodeset}`}</Descriptions.Item>}
                    {p.hugepage_kb ? <Descriptions.Item label={t('Hugepages')}>{p.hugepage_kb >= 1048576 ? '1 GB' : '2 MB'}</Descriptions.Item> : null}
                    {data.shared && <Descriptions.Item label={t('Shared pool')}>{data.shared}</Descriptions.Item>}
                </Descriptions>
            )}
            <Collapse ghost size="small" items={[{
                key: 'pin', label: t('Manual pinning'), children: (
                    <Space.Compact style={{ width: '100%', maxWidth: 360 }}>
                        <Input value={cpus} onChange={(e) => setCpus(e.target.value.replace(/\s/g, ''))} placeholder="2,6" />
                        <Button type="primary" disabled={!/^\d+(,\d+)*$/.test(cpus)} loading={busy} onClick={() => run(api.pinVmVds(id, cpus))}>{t('CPU pinning')}</Button>
                    </Space.Compact>
                ),
            }]} />
        </Card>
    );
};

export default VdsPinTab;
